import axios from 'axios'

export default {
    name: 'newsList',
    data() {
        let entries;
        return {
            entries: entries,
        }
    },
    created() {
        this.loadEntries();
    },
    methods: {
        loadEntries: function () {
            axios.get('/_/news', {
                params: {}
            })
                .then((response) => {
                    this.entries = [];
                    for (let entryData of response.data.entries) {
                        let entry = {
                            title: entryData.title,
                            url: entryData.url,
                            domain: entryData.domain,
                        };
                        this.entries.push(entry);
                    }
                });
        }
    }
}

